import { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import StyledButton from '../../generic/StyledButton'
import StyledSelect from '../../generic/StyledSelect'
import DraggableModal from '../../generic/DraggableModal'
import Typography from '@mui/material/Typography'
import { backendGetRequest, backendPostWithoutRefresh } from '../../../helpers/callBackend'
import { errorMessage } from '../../../helpers/errorMessageFunc'
import { message } from 'antd'

const CreateFundingSource = ({
  visible,
  handleCancelModal,
  entityId,
  bankAccountId,
  bankAccountName,
  setFundingSourceId,
}) => {
  const [accountNumber, setAccountNumber] = useState('')
  const [routingNumber, setRoutingNumber] = useState('')
  const [accountType, setAccountType] = useState('')

  const accountTypes = [
    { display_text: 'Checking', value: 'checking' },
    { display_text: 'Savings', value: 'savings' },
    // these are the other two forms of dwolla funding sources, I have them commented out for now because
    // I haven't done full testing of them yet
    // { display_text: "General Ledger", value: "general-ledger" },
    // { display_text: "Loan", value: "loan" },
  ]

  const handleInput = (event) => {
    setAccountType(event.target.value)
  }

  const handleSubmit = async () => {
    try {
      const fundingSourceResp = await backendPostWithoutRefresh('/api/arpari-dwolla/funding-source/', {
        routingNumber: routingNumber,
        accountNumber: accountNumber,
        bankAccountType: accountType,
        name: bankAccountName,
        entity_id: entityId,
        bank_account_id: bankAccountId,
      })

      if (!fundingSourceResp.data?.data?.microdeposits_initiated) {
        // failed to create microdeps
        throw new Error('Something went wrong initiating microdeposits')
      }

      setFundingSourceId(fundingSourceResp?.data?.data?.funding_source_id)
      handleCancelModal(false)
      message.success('Microdeposits initiated to verify this account. This may take a few days', 10)
    } catch (error) {
      errorMessage('Something went wrong initiating microdeposits')
    }
  }

  const getBankInformation = async () => {
    const accountNumResp = await backendGetRequest('/api/bank-account/detokenize', {
      params: {
        bank_account_id: bankAccountId,
        key: 'accountNumber',
      },
    })
    setAccountNumber(accountNumResp?.data?.account_number)
    const routingNumResp = await backendGetRequest('/api/bank-account/detokenize', {
      params: {
        bank_account_id: bankAccountId,
        key: 'routingNumber',
      },
    })
    setRoutingNumber(routingNumResp?.data?.routing_number)
  }

  useEffect(() => {
    if (!bankAccountId) {
      return
    }
    getBankInformation()
  }, [bankAccountId])

  return (
    <DraggableModal
      modalTitle={`Enable Payments for ${bankAccountName}`}
      modalVisible={visible}
      handleCancelModal={handleCancelModal}
      width='50%'
      content={
        <Stack spacing={1}>
          <Typography>
            To enable payments on your account, we need to verify with microdeposits. If you wish to proceed, click
            submit after verifying the information below. If it is incorrect, please update your account information in
            your dashboard first.
          </Typography>
          <Stack spacing={0.5} direction='row' alignItems='center'>
            <Typography sx={{ width: '30%' }}>Account Number</Typography>
            <Typography>{accountNumber}</Typography>
          </Stack>
          <Stack spacing={0.5} direction='row' alignItems='center'>
            <Typography sx={{ width: '30%' }}>Routing Number</Typography>
            <Typography>{routingNumber}</Typography>
          </Stack>
          <Stack spacing={0.5} direction='row' alignItems='center'>
            <Typography sx={{ width: '30%' }}>Account Type</Typography>
            <StyledSelect items={accountTypes} onChange={(event) => handleInput(event, 'bankAccountType')} />
          </Stack>
        </Stack>
      }
      actions={<StyledButton label='Submit' fontSize={14} onClick={handleSubmit} />}
    />
  )
}

export default CreateFundingSource
